import { useParams } from "react-router-dom";
import { InviteAccept } from "./pageComponents";

const ProjectInviteRoute = () => {
  const { token } = useParams();

  return <InviteAccept token={token} />;
};

export default ProjectInviteRoute;